export const GET_HOMEPAGE_BANNER_GROUP_START = 'GET_HOMEPAGE_BANNER_GROUP_START';
export const GET_HOMEPAGE_BANNER_GROUP_SUCCESS = 'GET_HOMEPAGE_BANNER_GROUP_SUCCESS';
export const GET_HOMEPAGE_BANNER_GROUP_FAILED = 'GET_HOMEPAGE_BANNER_GROUP_FAILED';

export const SAVE_BANNER_SLIDE_START = 'SAVE_BANNER_SLIDE_START';
export const SAVE_BANNER_SLIDE_SUCCESS = 'SAVE_BANNER_SLIDE_SUCCESS';
export const SAVE_BANNER_SLIDE_FAILED = 'SAVE_BANNER_SLIDE_FAILED';

export const DELETE_BANNER_SLIDE_START = 'DELETE_BANNER_SLIDE_START';
export const DELETE_BANNER_SLIDE_SUCCESS = 'DELETE_BANNER_SLIDE_SUCCESS';
export const DELETE_BANNER_SLIDE_FAILED = 'DELETE_BANNER_SLIDE_FAILED';

export const ADD_NEW_BANNER_SLIDE_START = 'ADD_NEW_BANNER_SLIDE_START';
export const ADD_NEW_BANNER_SLIDE_SUCCESS = 'ADD_NEW_BANNER_SLIDE_SUCCESS';
export const ADD_NEW_BANNER_SLIDE_FAILED = 'ADD_NEW_BANNER_SLIDE_FAILED';

export const getHomepageBannerGroupStart = () => ({
  type: GET_HOMEPAGE_BANNER_GROUP_START
});

export const getHomepageBannerGroupSuccess = (data) => ({
  type: GET_HOMEPAGE_BANNER_GROUP_SUCCESS,
  data
});

export const getHomepageBannerGroupFailed = (error) => ({
  type: GET_HOMEPAGE_BANNER_GROUP_FAILED,
  error
});

export const saveBannerSlideStart = () => ({
  type: SAVE_BANNER_SLIDE_START
});

export const saveBannerSlideSuccess = (data) => ({
  type: SAVE_BANNER_SLIDE_SUCCESS,
  data
});

export const saveBannerSlideFailed = (error) => ({
  type: SAVE_BANNER_SLIDE_FAILED,
  error
});

export const deleteBannerSlideStart = () => ({
  type: DELETE_BANNER_SLIDE_START
});

export const deleteBannerSlideSuccess = (id) => ({
  type: DELETE_BANNER_SLIDE_SUCCESS,
  id
});

export const deleteBannerSlideFailed = (error) => ({
  type: DELETE_BANNER_SLIDE_FAILED,
  error
});

export const addNewBannerSlideStart = () => ({
  type: ADD_NEW_BANNER_SLIDE_START
});

export const addNewBannerSlideSuccess = (data) => ({
  type: ADD_NEW_BANNER_SLIDE_SUCCESS,
  data
});

export const addNewBannerSlideFailed = (error) => ({
  type: ADD_NEW_BANNER_SLIDE_FAILED,
  error
});
